import { ThrowableStatus } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";
import { logException } from "@wss/error-tracking";

interface SaveFormSubmission {
  description: string;
  pageId: number;
  sectionId: number;
  formEntries: FormEntry[];
  recaptchaToken: string;
}

export interface FormEntry {
  formFieldId: number;
  formFieldName: string;
  entryValue?: string;
  sortOrder: number;
}

const fetchSaveFormSubmission = async (
  data: SaveFormSubmission,
): Promise<ThrowableStatus<Response>> => {
  try {
    const response = await fetch("/api/pagecreator/saveform", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      return {
        isError: true,
        status: response.status,
        error: new Error(response.statusText),
      };
    }

    return {
      isError: false,
      value: response,
    };
  } catch (e) {
    const error = new Error(
      "Error submitting lead form to /api/pagecreator/saveform",
      {
        cause: toError(e),
      },
    );

    await logException(error);

    return {
      error,
      status: null,
      isError: true,
    };
  }
};

export default fetchSaveFormSubmission;
